import {
  RedirectWithReplace,
  BreadCrumb,
  SkuSelector,
  RelatedProductsSlider,
  ProductPageHeader,
  ProductDetailGallery,
  ProductAdditionalInformation,
  HeartButton,
  Spinner,
  ProductBundle,
  useUtilities,
  isAuthenticated,
} from "@ten24/slatwall-storefront-react-private/global";
import { ProductPagePanels } from "../ProductDetail/ProductPagePanels";
import { ProductDetails } from "../ProductDetail/ProductDetails";
import {
  useGetEntityByUrlTitleAdvanced,
  useProductDetail,
  useReview,
} from "@ten24/slatwall-storefront-react-private/global";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import {
  disableInteractionSelector,
  getProductTypeRoute,
} from "@ten24/slatwall-storefront-react-private/global";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router";
import {
  ProductOutOfStock,
  validateProductOutOfStock,
} from "../ProductOutOfStock/ProductOutOfStock";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SkuOptions } from "../ProductDetail/SkuOptions";
import { ProductForm } from "../ProductDetail/ProductForm";
import { DynamicComponent } from '../DynamicComponent/DynamicComponent'
import { ProductDetailContext } from './ProductDetailContext'

const ProductDetailDisplay = (props) => {
  const pdpConfig = JSON.parse(props.productPageDisplayConfiguration); //Changes - accessing the configuration for PDP
  const [lastSelection, setLastSelection] = useState({
    optionGroupCode: "",
    optionCode: "",
  });
  const { eventHandlerForWSIWYG } = useUtilities();
  let location = useLocation();
  const navigate = useNavigate();
  const productTypeRoute = useSelector(getProductTypeRoute);
  const productTypeBase = useSelector(
    (state) => state.configuration.filtering.productTypeBase
  );
  const cart = useSelector(disableInteractionSelector);
  const {
    calculateAvaliableOptions,
    calculateAdditionalParamters,
    selectionToSku,
  } = useProductDetail();
  const { t } = useTranslation();
  const siteSetting = useSelector((state) => state.configuration.site.settings);
  // selection is an object of current paramters
  // optionGroupPairs is an array of current paramters key=value
  let params = queryString.parse(location.search, {
    arrayFormat: "separator",
    arrayFormatSeparator: ",",
  });
  let optionGroupPairs = location.search
    .replace("?", "")
    .split("&")
    .filter((param) => param.length);
  const urlTitle = location.pathname.split("/").reverse();
  const ratingData = useReview(urlTitle?.at(0));
  const [quantity, setQuantity] = useState(1);
  let {
    isFetching,
    product,
    productOptions,
    skus,
    error,
    attributeSets,
    productBundle,
    productBundleBuildOnAccount,
  } = useGetEntityByUrlTitleAdvanced(urlTitle?.at(0));
  if (error.isError) return null;

  let selectedSKu = selectionToSku(
    product,
    skus,
    optionGroupPairs,
    productOptions
  );
  if (params?.skuid && productOptions?.length) {
    // If we have a skuID we need to redirect to codes
    console.log("skuID found, waiting for skus", !product);
    const found = skus?.filter((sku) => sku.skuID === params.skuid);
    if (!found?.length) return <ProductDetailLoading />;
    if (found.length) {
      return navigate(
        {
          pathname: location.pathname,
          search: found?.at(0).slug,
        },
        { replace: true }
      );
    }
  }
  if (!product) return <RedirectWithReplace pathname="/404" />;
  if (optionGroupPairs.length === 0 && product.defaultSku_slug) {
    // This check is for no optionGroupPairs passed
    console.log("<------- product.defaultSku_slug", optionGroupPairs, product);

    return (
      <RedirectWithReplace
        pathname={location.pathname}
        search={product.defaultSku_slug}
      />
    );
  }
  //http://localhost:3006/product/demo-product

  const crumbs = product?.breadcrumbs
    ?.map((crumb) => {
      return {
        title: crumb.productTypeName,
        urlTitle: `/${productTypeRoute}/${crumb.urlTitle}`,
      };
    })
    .filter(
      (crumb) => crumb.urlTitle !== `/${productTypeRoute}/${productTypeBase}`
    );

  // const matchingSkus = filterSkusBySelectedOptions(skus, optionGroupPairs)
  let updatedProductOptions = calculateAvaliableOptions(
    productOptions,
    lastSelection,
    skus
  );
  let updateParams = calculateAdditionalParamters(
    optionGroupPairs,
    updatedProductOptions
  );

  if (updateParams.length) {
    // http://localhost:3006/product/test-product?soccerBallSize=5 ==>  soccerBallColor=green is added
    console.log("Add additional optionGroupPairs because of option matrix");

    return (
      <RedirectWithReplace
        pathname={location.pathname}
        search={[...optionGroupPairs, updateParams].join("&")}
      />
    );
  }
  let isDisabled = isFetching || cart.isFetching || !selectedSKu?.skuID;
  if (productOptions?.length === 0 && product.skus.length > 0) {
    console.log("This is a product with skus without option groups");

    if (params?.skuid) {
      selectedSKu = skus?.filter((sku) => sku.skuID === params.skuid)?.at(0);
    } else {
      selectedSKu = skus
        ?.filter((sku) => sku.skuID === product.defaultSku_skuID)
        ?.at(0);
    }
    isDisabled = false;
  }

  if (!product?.productID) return <ProductDetailLoading />;

  //set out of stock flag if loading is completed and calculatedQATS of selected sku is not valid
  const isOutOfStock =
    !isFetching && !cart.isFetching && validateProductOutOfStock(selectedSKu);

  return (
    <ProductDetailContext.Provider value={{ ratingData }}>
      {product?.productID && (
        <ProductPageHeader title={product.productName}>
          <BreadCrumb crumbs={crumbs} />
        </ProductPageHeader>
      )}
      {product?.productID && (
        <Helmet title={product.settings.productHTMLTitleString} />
      )}

      <div className="container mt-5">
        {selectedSKu &&
          pdpConfig?.enableFavorites && ( //changes-favourites display control from config
            <div className="d-flex justify-content-end">
              <HeartButton
                skuID={selectedSKu.skuID}
                className="btn-wishlist mr-0 flex-end"
              />
            </div>
          )}
        <div className="row">
          <div className="col-sm-12 col-lg-5 mb-4 mb-md-0">
            <ProductDetailGallery
              productUrlTitle={urlTitle?.at(0)}
              skuID={selectedSKu?.skuID}
            />
            {/*changes-product description moved below the image slider */}
            <div
              className="pt-1"
              onClick={eventHandlerForWSIWYG}
              dangerouslySetInnerHTML={{
                __html: product.productDescription,
              }}
            />
            {product?.productID && (
              <ProductAdditionalInformation
                additionalInformation={product.additionalInformation}
              />
            )}
          </div>
          <div className="col-sm-12 col-lg-6 offset-lg-1">
            {product?.productID && (
              <ProductDetails
                sku={selectedSKu}
                product={product}
                config={pdpConfig}
                ratingData={ratingData}
              />
            )}
            {!isFetching && (
              <SkuOptions
                setLastSelection={setLastSelection}
                sku={selectedSKu}
                selection={params}
                productOptions={updatedProductOptions}
                skus={skus}
                config={pdpConfig}
              />
            )}
            {!isFetching && product.skus.length > 1 && (
              <SkuSelector
                sku={selectedSKu}
                selection={params}
                productOptions={updatedProductOptions}
                skus={skus}
              />
            )}

            {pdpConfig.input.showInventory && (
              <ProductOutOfStock isFetching={isFetching} sku={selectedSKu} />
            )}

            {siteSetting.sitePurpose !== "Non-Transactional" && (
              <div className="d-flex align-items-center">
                {!isOutOfStock && (
                  <ProductForm
                    sku={selectedSKu}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    isDisabled={isDisabled}
                    isLoading={isFetching || cart.isFetching}
                    config={pdpConfig}
                  />
                )}
              </div>
            )}

            {!isAuthenticated() &&
              pdpConfig.price.showCriteria === "showForAuthenticatedUsers" && ( //changes - config validation and alerts for showing trade price.
                <div
                  className="alert alert-danger pdp-login-alert"
                  role="alert">
                  {t("frontend.loginforprice")}
                  <br />
                  <Link to="/my-account/login">
                    {" "}
                    {t("frontend.account.login")}{" "}
                  </Link>
                </div>
              )}
            {product?.productID && (
              <div className="row mb-4">
                <div className="col-md-12">
                  <ProductPagePanels
                    product={product}
                    attributeSets={attributeSets}
                  />
                </div>
              </div>
            )}
            {props.innerElements?.map((rowEl, rowIdx) => (
                <DynamicComponent el={rowEl} key={rowIdx} />
              )
            )}
          </div>
        </div>
        <ProductBundle
          productBundle={productBundle}
          productBundleBuildOnAccount={productBundleBuildOnAccount}
          productID={product?.productID}
        />
      </div>
      {/* changes - using config to validate display of relatedproducts and reviews */}
      {pdpConfig?.showRelatedProducts && (
        <RelatedProductsSlider productUrlTitle={urlTitle?.at(0)} />
      )}
    </ProductDetailContext.Provider>
  );
};

const ProductDetailLoading = () => {
  return (
    <div className="container mt-5">
      <Spinner />
      <div className="d-flex justify-content-end"></div>
      <div className="row">
        <div className="col-sm-6 col-md-4 mb-4 mb-md-0"></div>
        <div className="col-sm-6 col-md-6 offset-md-1">
          <div className="row mb-4">
            <div className="col-md-12"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ProductDetailDisplay };
